import { useCurrentNetwork } from 'hooks';
import { useEffect, type FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import type { Network } from 'types/shared';
import { trackNetworkSessionView } from 'lib/datadog';

export const ALLOWED_NETWORKS: Network[] = ['facebook', 'google', 'snapchat', 'tiktok', 'x'];

interface Props {
  children: React.ReactNode;
}
const NetworkProvider: FC<Props> = ({ children }) => {
  const network = useCurrentNetwork();
  const { network: networkParam } = useParams<{ network: Network }>();
  const isNetworkInvalid = !!network && !ALLOWED_NETWORKS.includes(network);

  useEffect(() => {
    if (isNetworkInvalid) {
      localStorage.removeItem('_network');
    } else {
      localStorage.setItem('_network', String(network));
    }
  }, [network, isNetworkInvalid]);

  useEffect(() => {
    if (networkParam && ALLOWED_NETWORKS.includes(networkParam)) {
      trackNetworkSessionView(networkParam);
    }
  }, [networkParam]);

  if (isNetworkInvalid) {
    return <Navigate to="/networks" replace />;
  }

  return children;
};

export default NetworkProvider;
